import { useTranslation } from "react-i18next";
import { LaptopIcon } from "@hr/common/icons.jsx";

export const CustomNoRowsOverlay = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-column gap-3" style={{ width: "22rem" }}>
      <LaptopIcon />
      <h2 className="mb-0">{t("NoIndividualsToDisplay","Ei näytettäviä yksilöitä")}</h2>
      <p>{t("HolidayPeriodChangeInfo","Vaihda lomakautta taulukon yläpuolelta, tai nollaa suodattimet klikaamalla hiiren oikealla taulussa.")}</p>
    </div>
  );
};
